<span class="arrow" [ngClass]="direction"></span>
